import { User } from 'app/core/models';
import { Dictionary } from 'app/shared/models';
import { RelatedToType } from 'app/shared/enums';

export interface ImportResponse {
  account_id: number;
  auto_mapping?: Array<{ header: string; field: ImportField }>;
  created_at: string;
  data_preview?: Dictionary<string[]>;
  deleted_at: string;
  document: DocumentDetails;
  errors: string[];
  failures_document: DocumentDetails;
  headers: string[];
  id: number;
  mapping: Dictionary<ImportField>;
  mode: ImportModeType;
  name: string;
  records_created_count: number;
  records_updated_count: number;
  related_to_type: RelatedToType;
  result_path: any;
  rows_processed_count: number;
  status: ImportStatusEnum;
  updated_at: string;
  user: User;
  user_id: number;
}

export interface DocumentDetails {
  attachment_content_type: string;
  attachment_file_size: number;
  created_at: string;
  created_by: User;
  document_section: any;
  id: number;
  integrated_storage: any;
  original_url: string;
  pdf_url: string;
  public_name: string;
}

export enum ImportStatusEnum {
  Imported = 'imported',
  ImportedWithFailures = 'imported_with_failures',
  InRunQueue = 'in_run_queue',
  Invalid = 'invalid',
  MappingRequired = 'mapping_required',
  New = 'new',
  ReadyToRun = 'ready_to_run',
  Running = 'running',
}

export interface ImportField {
  label: string;
  name: string;
}

export interface OutputImportDialogData {
  recordId: number;
}

export interface InputImportDialogData {
  accountId?: number;
  editMode?: boolean;
  import: ImportResponse;
}

export enum ImportModeEnum {
  Create = 'create',
  Update = 'update',
  CreateAndUpdate = 'create_and_update',
}

export type ImportModeType = 'create' | 'update' | 'create_and_update';
